import React from "react";
import EditStaffPage from "../../../../../entities/DashboardPage/AccountingModule/StaffPage/EditStaffPage";

const EditStaff = () => {
  return(
    <EditStaffPage/>
  )
}

export default EditStaff